import { FC, useCallback } from 'react';
import { useFormikContext } from 'formik';

import Checkbox from '@mui/material/Checkbox';

import { DiskCleanupFormValues } from 'components/DiskCleanup';
import { CleanupTool } from 'components/DiskCleanupContext';

type Props = {
  tools: CleanupTool[];
};

const DiskCleanupSelectAll: FC<Props> = ({ tools }) => {
  const { values, setFieldValue } = useFormikContext<DiskCleanupFormValues>();

  const checked = tools.reduce(
    (acc, tool) => acc && values[tool].selected,
    true
  );

  const indeterminate = tools.reduce(
    (acc, tool) => acc || values[tool].selected,
    false
  );

  const handleChange = useCallback(() => {
    tools.forEach(tool => {
      setFieldValue(`${tool}.selected`, !checked);
    });
  }, [checked, setFieldValue, tools]);

  return (
    <Checkbox
      checked={checked}
      indeterminate={!checked && indeterminate}
      onChange={handleChange}
    />
  );
};

export default DiskCleanupSelectAll;
